/**
 * @format
 */
import { Component, ElementRef, OnInit, ViewChild, ViewEncapsulation } from "@angular/core";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { LinkToolService } from "../../services/link-tool.service";
import { LinkTextUrlType } from "../../types/link-text-value.type";
import { Dropdown } from "primeng/dropdown";

@Component({
   selector: "link-modal",
   templateUrl: "link-modal.component.html",
   styles: [
      `
         .url__group {
            flex-direction: row;
            display: flex;
         }
         div.url__dropdown,
         div.url__dropdown div:nth-child(3) {
            -moz-border-radius-topright: 0;
            -webkit-border-top-right-radius: 0;
            border-top-right-radius: 0;
            -moz-border-radius-bottomright: 0;
            -webkit-border-bottom-right-radius: 0;
            border-bottom-right-radius: 0;
         }
         div.url__dropdown {
            min-width: 7em;
         }
         .url__input {
            border-top-left-radius: 0;
            border-bottom-left-radius: 0;
         }
      `,
   ],
   encapsulation: ViewEncapsulation.None,
})
export class LinkModalComponent implements OnInit {
   url: string;
   text: string;
   isConfirm: boolean;
   protocolOptions: Array<{ value: string }>;
   selectedProtocol: { value: string };
   @ViewChild("ddProtocol") protocolDropdown: Dropdown;
   @ViewChild("inputUrl") urlInput: ElementRef<HTMLInputElement>;

   constructor(
      private modalService: BsModalService,
      private modalReference: BsModalRef,
      private linkToolService: LinkToolService
   ) {}

   ngOnInit() {
      this.protocolOptions = [{ value: "https://" }, { value: "http://" }];
      this.selectedProtocol = this.protocolOptions[0];
      this.text = document.getSelection().toString();
      this.url = "";
   }

   successModal(): void {
      const linkTextValueType: LinkTextUrlType = {
         url: `${this.selectedProtocol.value}${this.url}`,
         text: this.text,
         isConfirmLink: this.isConfirm,
      };
      this.linkToolService.onLinkModalClose$.next(linkTextValueType);
      this.modalReference.hide();
   }

   closeModal(): void {
      this.modalReference.hide();
   }

   useConfirm(): void {
      this.isConfirm = !this.isConfirm;
      if (this.isConfirm) {
         this.url = "using confirm appointment link";
      } else {
         this.url = "";
      }
   }

   sanitizeUrl(): void {
      this.setSelectedProtocol(this.url);
      this.url = this.url.replace(/^(https?)*:\/\//g, "");
      this.urlInput.nativeElement.focus();
   }

   private setSelectedProtocol(value: string): void {
      const matchedValue = value.match(/^(https?)*:\/\//g);

      if (!Boolean(matchedValue)) {
         return;
      }

      const protocol = this.protocolOptions.find((optionProtocol) => optionProtocol.value === matchedValue.toString());

      this.protocolDropdown.updateSelectedOption(protocol);
      this.protocolDropdown.focus();
      this.selectedProtocol = protocol;
   }
}
